/**
 * Plugin Text Domain that will be used throughout the plugin
 */

export const TEXT_DOMAIN = "columns-pro";
